var render, staticRenderFns
import script from "./paperTypeList.vue?vue&type=script&lang=js&"
export * from "./paperTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c548af0c",
  null
  
)

export default component.exports